import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { macromillDesignsystemPageMeta, macromillDesignsystemSchema } from 'components/common/schema'
import Template from 'components/cases/macromill-designsystem'

const MacromillDesignsystem: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...macromillDesignsystemPageMeta} />
      <JsonLd data={macromillDesignsystemSchema} />
      <Template />
    </>
  )
}

export default MacromillDesignsystem
